<template>
    <ConfirmDialog :closeOnEscape="false" :closable="false" :draggable="false"></ConfirmDialog>
    <Dialog :header='`La tua sessione scadrà in ${Math.floor(timeLeft/1000)}"`'
            v-model:visible="sessionAboutToExpire"
            :style="{width: '275px'}"
            :modal="true"
            :closeOnEscape="false"
            :closable="false"
            :autoZIndex="true"
            :baseZIndex="9998"
    >
        <div class="confirmation-content">
            <i class="fas fa-user-clock mr-3" style="font-size: 2rem" />
            <span>Sei ancora attivo?</span>
        </div>
        <template #footer>
            <!-- <Button label="No" icon="pi pi-times" @click="closeConfirmation" class="p-button-text"/> -->
            <Button label="Sì, rinnova sessione" icon="pi pi-check" @click="refreshSession" autofocus />
        </template>
    </Dialog>

    <Sidebar
            class="black-sidebar"
            v-model:visible="globalLoading" :dismissable="false" :showCloseIcon="false" :modal="false" position="full">
        <ProgressSpinner class="spinner-center"/>
    </Sidebar>
    <Sidebar
            class="block-sidebar"
            v-model:visible="globalBlock" :dismissable="false" :showCloseIcon="false" :modal="false" position="full">
        <div><i class="pi pi-lock" style="font-size: xx-large"/></div>
        <div>Questa sezione può essere utilizzata in una sola tab alla volta. Chiudi tutte le altre tab.</div>
    </Sidebar>
    <DynamicDialog/>
    <div v-if="authorized" :class="containerClass" :data-theme="colorScheme" @click="onDocumentClick($event)">
        <div class="layout-content-wrapper">
            <AppTopBar :topbarNotificationMenuActive="topbarNotificationMenuActive" :topbarUserMenuActive="topbarUserMenuActive"
                       :layoutMode="layoutMode" :menu="menu" :menuActive="menuActive" :staticMenuMobileActive='staticMenuMobileActive'
                       @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"
                       @settings-click="onConfigButtonClick" @menu-button-click="onMenuButtonClick"
                       @search-click="toggleSearch" @topbar-notification="onTopbarNotificationMenuButtonClick"
                       @topbar-user-menu="onTopbarUserMenuButtonClick" @right-menu-click="onRightMenuButtonClick"
                       @right-menubutton-click="onRightMenuButtonClick" @logout-click="onLogoutClick"
            />

            <div class="layout-content">
                <Toast :autoZIndex="false" style="z-index: 1000001" />
                <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                    <template v-if="route.meta.breadcrumb">
                        <span>{{route.meta.breadcrumb[0].label}}</span>
                    </template>
                </div>
                <router-view/>
            </div>
            <AppFooter/>
        </div>

        <AppRightMenu :rightMenuActive="rightMenuActive" @right-menu-click="onRightMenuClick"></AppRightMenu>

        <AppConfig v-model:configActive="configActive" v-model:layoutMode="layoutMode" v-model:menuTheme="menuTheme" v-model:colorScheme="colorScheme" @config-click="onConfigClick" @config-button-click="onConfigButtonClick"></AppConfig>

        <AppSearch :searchActive="searchActive" @search-click="onSearchClick" @search-hide="onSearchHide"/>
    </div>
</template>

<script>
import { ref, computed, watch, onBeforeUnmount, onBeforeMount, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from "primevue/usetoast"
import { usePrimeVue } from "primevue/config"
import XLiteService from '@/services/XLiteService.js'
import SocketIOService from '@/services/SocketIOService.js'
import EventBus from './event-bus'
import AppTopBar from "./AppTopbar"
import AppFooter from "./AppFooter"
import AppConfig from "./AppConfig"
import AppSearch from "./AppSearch"
import AppRightMenu from "./AppRightMenu"
const debug = require('debug')('xlite-web-client:app')
export default {
    setup() {
       
        onMounted(() => {
            debug('App mounted')
            if(authorized.value){
                setupSocketConnection()
            
                expCheckInterval = setInterval(async () => {
                    now.value = new Date()
                    //const formattedTimeLeft = new Date(timeLeft.value).toISOString().slice(11, 19)
                    //if(e.value) debug(`${now.value.toLocaleTimeString('it-IT')} - ${e.value.toLocaleTimeString('it-IT')} ➜ ${formattedTimeLeft} (${timeLeft.value} Vs ${sessionExpireWarningTime} ${timeLeft.value > sessionExpireWarningTime ? '👍🏻' : '⚠️'})`)
                    if (timeLeft.value && timeLeft.value <= sessionExpireWarningTime && !userWarned) {
                        userWarned = true
                        debug(`⚠️⚠️ Session about to expire in ${timeLeft.value / 1000}"`)
                        sessionAboutToExpire.value = true
                    } else if (timeLeft.value <= 0) {
                        store.dispatch('enableGlobalLoading')
                        clearInterval(expCheckInterval)
                        debug('❌❌ Session expired!')
                        sessionAboutToExpire.value = false
                        await store.dispatch('setSto', true)
                        await store.dispatch('logout')
                        router.replace({ name: 'login' })
                    }
                }, 1000)
            }
        })

        onBeforeMount(() => {
            buildmenu(dbPaths.value)
        })

        onBeforeUnmount(() => {
            debug('App is about to unmount')
            closeSocketConnection()
            unwatchDbPaths()
            unwatchOperatorName()
            unwatchStt()
            unwatchAuthorized()
            clearInterval(expCheckInterval)
        })

        const refreshSession = () => {
            store.dispatch('enableGlobalLoading')
            XLiteService.operatorInfo()
                .then(async response => {
                    //throw new Error('thrown on purpose')
                    // eslint-disable-next-line no-unreachable
                    const data = response.data
                    debug('Then', data)
                    if (data.li !== 'lasting') {
                        debug('❌❌ Impossible to renew session!')
                        sessionAboutToExpire.value = false
                        clearInterval(expCheckInterval)
                        await store.dispatch('logout')
                        await store.dispatch('setOpd', true)
                        router.replace({ name: 'login' })
                    } else {
                        userWarned = false
                        sessionAboutToExpire.value = false
                        toast.add({ severity: 'success', summary: `Sessione rinnovata`, life: toastLife })
                    }
                })
                .catch((err) => {
                    debug('Error', err.response)
                    toast.add({ severity: 'error', summary: `Impossibile rinnovare la sessione`, life: toastLifeError })
                })
                .finally(() => {
                    store.dispatch('disableGlobalLoading')
                })
        }
       
        const primevue = usePrimeVue()
        const store = useStore()
        const router = useRouter()
        const route = useRoute()
        const toast = useToast()
        const toastLife = 3500
        //const toastLifeWarn = 5500
        const toastLifeError = 7500
        let expCheckInterval

        const dbPaths = computed(() => store.getters.dbPaths)
        const operatorName = computed(() => store.getters.operator)
        const operatorFirstName = computed(() => operatorName.value.split(' ')[0])
        const authorized = computed(() => store.getters.a)
        const e = computed(() => store.getters.e)
        //const stt = computed(() => store.getters.stt)
        const now = ref(new Date())
        const timeLeft = computed(() => e.value - now.value - 5000)
        const sessionAboutToExpire = ref(false)
        const sessionExpireWarningTime = 60000
        let userWarned = false
        const globalLoading = computed(() => store.getters.globalLoading)
        const globalBlock = computed(() => store.getters.globalBlock)
        
        

        const menu = ref([])
        const menuElements = [
            {
                label: "Dashboard", icon: "far fa-gauge-high",
                items: [
                    {label: "Principale", icon: "pi pi-fw pi-home", to: "/"},
                ],
            },
            {
                label: "Moduli", icon: "pi pi-th-large",
                items: [
                    {label: "Articoli", icon: "fas fa-clothes-hanger", to: "/articletable"},
                    {label: "Barcode", icon: "fas fa-barcode", to: "/barcode"},
                    {label: "Ricerca", icon: "fas fa-magnifying-glass", to: "/search"},
                    {label: "Media Gallery", icon: "fas fa-images", to: "/mediagallery"},
                    {label: "Analytics", icon: "pi pi-fw pi-chart-bar", to: "/analytics"},
                    {label: 'Analytics operatore', icon: "far fa-chart-user", to: "/operatoranalytics"},
                ],
            }
        ]
        if(!process.env.VUE_APP_ARGV.split(',').includes('--dev')){
            //
        }

        const setupSocketConnection = () => {
            SocketIOService.setupSocketConnection()
        }

        const closeSocketConnection = () => {
            SocketIOService.disconnect()
        }

        const buildmenu = (dbPaths) => {
            //debug('Store-defined-routes:', dbPaths)
            //debug('Menu elements:', menuElements)
            const currentMenuElements = JSON.parse(JSON.stringify(menuElements))
            if(dbPaths.length){
                currentMenuElements.forEach(element => {
                    const items = element.items
                    let index = items.length-1
                    while (index >= 0) {
                        //debug(items[index].to)
                        if (!dbPaths.includes(items[index].to)) {
                            //debug(`NOT in dbPaths`)
                            items.splice(index, 1);
                        } else {
                            //debug(`IN dbPaths`)
                        }
                        if(items[index] && items[index].to == '/operatoranalytics'){
                            items[index].label = `Analytics ${operatorFirstName.value}`
                        }
                        index -= 1;
                    }
                });
                
                //debug(menuElements)
                menu.value = currentMenuElements
            }
        }

        const unwatchDbPaths = store.watch(
            (state, getters) => getters.dbPaths,
                                (newValue) => {
                                    debug('dbPaths change detected', newValue)
                                    buildmenu(dbPaths.value)
                                },
                                {deep: true, immediate: false}
        )

        
        const unwatchOperatorName = store.watch(
            (state, getters) => getters.operator,
                                (newValue) => {
                                    debug('operator change detected', newValue)
                                    buildmenu(dbPaths.value)
                                },
                                {deep: true, immediate: false}
        )
        

        const unwatchAuthorized = store.watch(
            (state, getters) => getters.a,
                                (newValue) => {
                                    debug('authorized change detected', newValue)
                                    if (newValue) {
                                        setupSocketConnection()
                                    }
                                }
        )

        const unwatchStt = store.watch(
            (state, getters) => getters.stt,
                                (newValue) => {
                                    debug('stt change detected', newValue)
                                    if (newValue != false) {
                                        debug('❌❌ Session terminated by other login!')
                                        onLogoutClick()
                                    }
                                }
        )
        
        const menuActive = ref(false)
        const layoutMode = ref("static")
        const colorScheme = ref("light")
        const menuTheme = ref("layout-sidebar-darkgray")
        const overlayMenuActive = ref(false)
        const staticMenuDesktopInactive = ref(false)
        const staticMenuMobileActive = ref(false)
        const menuClick = ref(false)
        const searchActive = ref(false)
        const searchClick = ref(false)
        const userMenuClick = ref(false)
        const topbarUserMenuActive = ref(false)
        const notificationMenuClick = ref(false)
        const topbarNotificationMenuActive = ref(false)
        const rightMenuClick = ref(false)
        const rightMenuActive = ref(false)
        const configActive = ref(false)
        const configClick = ref(false)

        const containerClass = computed(() => {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": layoutMode.value === "overlay",
                    "layout-static": layoutMode.value === "static",
                    "layout-slim": layoutMode.value === "slim",
                    'layout-horizontal': layoutMode.value === 'horizontal',
                    "layout-sidebar-dim": colorScheme.value === "dim",
                    "layout-sidebar-dark": colorScheme.value === "dark",
                    "layout-overlay-active": overlayMenuActive.value,
                    "layout-mobile-active": staticMenuMobileActive.value,
                    "layout-static-inactive": staticMenuDesktopInactive.value && layoutMode.value === "static",
                    "p-input-filled": primevue.config.inputStyle === "filled",
                    "p-ripple-disabled": !primevue.config.ripple,
                },
                colorScheme.value === "light" ? menuTheme.value : "",
            ]
        })

        watch(
            /*
            route,
            () => {
                menuActive.value = false
                toast.removeAllGroups()
            }
            */

            () => route.fullPath,
                (newPath, oldPath) => {
                    debug('new path', newPath, oldPath)
                    debug('old path', oldPath)
                    menuActive.value = false
                    toast.removeAllGroups()
                }
        )

        const onLogoutClick = async () => {
            clearInterval(expCheckInterval)
            await store.dispatch('logout')
            router.replace({ name: 'login' })
        }

        const onDocumentClick = () => {
            if (!searchClick.value && searchActive.value) {
                onSearchHide()
            }

            if (!userMenuClick.value) {
                topbarUserMenuActive.value = false;
            }

            if (!notificationMenuClick.value) {
                topbarNotificationMenuActive.value = false;
            }

            if (!rightMenuClick.value) {
                rightMenuActive.value = false;
            }

            if (!menuClick.value) {
                if (isSlim() || isHorizontal()) {
					EventBus.emit('reset-active-index');
					menuActive.value = false;
                }

                if (overlayMenuActive.value || staticMenuMobileActive.value) {
                    hideOverlayMenu();
                }

                unblockBodyScroll();
            }

            if (configActive.value && !configClick.value) {
                configActive.value = false;
            }

            searchClick.value = false;
            configClick.value = false;
            userMenuClick.value = false;
            rightMenuClick.value = false;
            notificationMenuClick.value = false;
            menuClick.value = false;
        }

        const onMenuClick = () => {
            menuClick.value = true;
        }

        const onMenuButtonClick = (event) => {
            menuClick.value = true;
            topbarUserMenuActive.value = false;
            topbarNotificationMenuActive.value = false;
            rightMenuActive.value = false;

            if (isOverlay()) {
                overlayMenuActive.value = !overlayMenuActive.value;
            }

            if (isDesktop()) {
                staticMenuDesktopInactive.value = !staticMenuDesktopInactive.value;
            } else {
                staticMenuMobileActive.value = !staticMenuMobileActive.value;
                if (staticMenuMobileActive.value) {
                    blockBodyScroll();
                } else {
                    unblockBodyScroll();
                }
            }

            event.preventDefault();
        }

        const onMenuItemClick = (event) => {
			if (!event.item.items) {
				EventBus.emit('reset-active-index');
				hideOverlayMenu();
			}
			if (!event.item.items && (isSlim() || isHorizontal())) {
                menuActive.value = false;
            }
        }

		const onRootMenuItemClick = () => {
            menuActive.value = !menuActive.value;
        }

        const onTopbarUserMenuButtonClick = (event) => {
            userMenuClick.value = true;
            topbarUserMenuActive.value = !topbarUserMenuActive.value;

            hideOverlayMenu();

            event.preventDefault();
        }

        const onTopbarNotificationMenuButtonClick = (event) => {
            notificationMenuClick.value = true;
            topbarNotificationMenuActive.value = !topbarNotificationMenuActive.value;

            hideOverlayMenu();

            event.preventDefault();
        }

        const toggleSearch = () => {
            searchActive.value = !searchActive.value;
            searchClick.value = true;
        }

        const onSearchClick = () => {
            searchClick.value = true;
        }

        const onSearchHide = () => {
            searchActive.value = false;
            searchClick.value = false;
        }

        const onRightMenuClick = () => {
			rightMenuClick.value = true;
		}

        const onRightMenuButtonClick = (event) => {
			rightMenuClick.value = true;
			rightMenuActive.value = !rightMenuActive.value;
			hideOverlayMenu();
			event.preventDefault();
		}

        const onConfigClick = () => {
            configClick.value = true;
        }

        const onConfigButtonClick = () => {
            configActive.value = !configActive.value;
            configClick.value = true;
        }

        const hideOverlayMenu = () => {
            overlayMenuActive.value = false;
            staticMenuMobileActive.value = false;
            unblockBodyScroll();
        }

        const blockBodyScroll = () => {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        }

        const unblockBodyScroll = () => {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                    'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        }

        const isSlim = () => {
            return layoutMode.value === "slim";
        }

        const isHorizontal = () => {
            return layoutMode.value === "horizontal";
        }

        const isOverlay = () => {
            return layoutMode.value === "overlay";
        }

        const isDesktop = () => {
            return window.innerWidth > 1091;
        }

        return {
            route,
            authorized,
            menuActive,
            layoutMode,
            colorScheme,
            menuTheme,
            overlayMenuActive,
            staticMenuDesktopInactive,
            staticMenuMobileActive,
            menuClick,
            searchActive,
            searchClick,
            userMenuClick,
            topbarUserMenuActive,
            notificationMenuClick,
            topbarNotificationMenuActive,
            rightMenuClick,
            rightMenuActive,
            configActive,
            configClick,
            menu,
            containerClass,
            globalLoading,
            globalBlock,
            sessionAboutToExpire,
            timeLeft,

            onLogoutClick,
            onDocumentClick,
            onMenuClick,
            onMenuButtonClick,
            onMenuItemClick,
            onRootMenuItemClick,
            onTopbarUserMenuButtonClick,
            onTopbarNotificationMenuButtonClick,
            toggleSearch,
            onSearchClick,
            onSearchHide,
            onRightMenuClick,
            onRightMenuButtonClick,
            onConfigClick,
            onConfigButtonClick,
            hideOverlayMenu,
            blockBodyScroll,
            unblockBodyScroll,
            isSlim,
            isHorizontal,
            isOverlay,
            isDesktop,
            refreshSession
        }
    },
    components: {
        AppTopBar,
        AppFooter,
        AppConfig,
        AppSearch,
        AppRightMenu,
    },
};
</script>

<style lang="scss">
@import "App.scss";
</style>
